import React from 'react'
import Header from './layout/Header'
import Footer from './layout/Footer'
import './AboutUsPage.css'
import { useState } from 'react'
import AboutUsLanding from '../components/LandingComponents/AboutUsLanding'
import MeetTeam from '../components/MeetTeam/MeetTeam'
import AboutUsBelow from '../components/LandingComponents/AboutUsBelow'

const AboutUsPage = () => {
  const [show,setShow] = useState(false)
  const backgroundBlur = (show) => {
    setShow(show)
    setBg(show)
  }
  const [bg,setBg] = useState(false)

  return (
    <div>
      <div className='bg-[url("/src/assets/aboutus.png")] bg-cover mb-32 xl:mb-14'>
        <Header setShow={backgroundBlur}/>
        <AboutUsLanding />
      </div>
      <AboutUsBelow />

      {/* <div className="bg-meet-image bg-auto bg-no-repeat mt-10">
        <MeetTeam />
      </div> */}

        
      <MeetTeam />
      <Footer />
    </div>
  )
}

export default AboutUsPage